import { cn } from "@/lib/utils"

interface SummaryCategoryProps {
  title: string
  percentage: string
  color: "primary" | "red" | "orange" | "purple"
  items: Array<{ label: string; value: string }>
}

export function SummaryCategory({ title, percentage, color, items }: SummaryCategoryProps) {
  const colorClasses = {
    primary: "text-brand-primary",
    red: "text-brand-red",
    orange: "text-orange-500",
    purple: "text-purple-500",
  }

  return (
    <div className="mb-4">
      {/* Category Header */}
      <div className="flex items-center justify-between mb-2">
        <span className={cn("font-semibold text-base", colorClasses[color])}>{title}</span>
        <span className={cn("font-semibold text-lg", colorClasses[color])}>{percentage}</span>
      </div>

      {/* Category Items */}
      <div className="space-y-1">
        {items.map((item, index) => (
          <div key={index} className="flex items-center justify-between text-sm text-gray-600 pl-2">
            <span>{item.label}</span>
            <span>{item.value}</span>
          </div>
        ))}
      </div>
    </div>
  )
}
